export const legalContent = {
  privacy: {
    title: {
      fr: "Politique de confidentialité",
      en: "Privacy Policy",
    },
    intro: {
      fr: "Cette page présente les principes clés de notre politique de confidentialité. Le document intégral propre à votre marché est aussi accessible directement sur cette page.",
      en: "This page highlights the key principles of our privacy policy. The full market-specific document is also available directly on this page.",
    },
  },
  terms: {
    title: {
      fr: "Conditions d’utilisation",
      en: "Terms of Use",
    },
    intro: {
      fr: "Les conditions varient selon le marché et encadrent notamment l’admissibilité, la commande, le paiement et la livraison. Le document intégral propre à votre marché est intégré ci-dessous.",
      en: "The terms vary by market and govern eligibility, ordering, payment, and delivery. The full market-specific document is embedded below.",
    },
  },
};
